import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmailPasswordCredentials } from '../../core/models/email-password-credentials';
import { Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '../../core/services/auth.service';
import { Constants } from '../../core/config/Constants';
import { Router } from '@angular/router';
import { UtilityService } from '../../core/services/utility.service';
import { ExtraService } from '../../core/services/extra.service';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  providers:[AuthService,FormBuilder]
})
export class ForgotPasswordComponent implements OnInit {

  email :string;
  errorMessage:string;
  isError :boolean = false;
  
    
  constructor(private authService: AuthService,private router: Router) { }
  
    ngOnInit() {}

    submit(){
      this.isError = false;
      if(this.email != null && this.email.trim().length >1){
        this.authService.resetPassword(this.email)
        .then((res) => {
          this.errorMessage = 'Mail Sent';
          this.isError = true;
        }).catch((error) =>{
          this.errorMessage = error.message;
          this.isError = true;
        });
      }else{
        this.errorMessage = 'Please Enter Email';
        this.isError = true;
      }
    }
}



// WEBPACK FOOTER //
// /app/src/app/user/forgot-password/forgot-password.component.ts